import React, { useState, useEffect, useContext, useMemo } from 'react'
import { Form, Toast } from 'antd-mobile';
import dayjs from 'dayjs'
import moment from 'moment';
import { UserContext } from 'utils/getContext'
import { onSubmitForm } from "api/api";
import { employPage1, employPage2, employPage3 } from 'data/employRegForm';
import { getAreaObj, getUserObj, getJobWantedObj, guid } from 'utils/getData'
import { judgeSex, userInfoHide, idCardHide,infoCardType } from "utils/ruleType";
import { transformDate } from 'utils'
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 就业登记 */
export function EmployReg() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, birthday, idNum } = userInfo ? userInfo : {}
  const [formId, setFormId] = useState('');
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [areaContent, setAreaContent] = useState([])
  const [jobWantContent, setJobWantContent] = useState([])
  const title = ['申请人信息', '就业信息', '其他', '提交申请']
  const pageData = [employPage1, employPage2, employPage3]

  const today = dayjs().format('YYYY-MM-DD')

  /** 对发出的参数数据【postInfo】进行处理 */
  const postInfo = useMemo(() => {
    return {
      serviceId: 117,// 上传表单ID
      params: {
        T_PSM_EmpRgt: {
          ...postData,
          FTYPE: 42,
          FBIRTH: postData.FBIRTH ? moment(postData.FBIRTH).format('YYYY-MM-DD') : postData.FBIRTH,
          FGRADTIME: postData.FGRADTIME ?
            moment(postData.FGRADTIME).format('YYYYMM') * 1 : postData.FGRADTIME,
          FORMID: formId,
          FILE: 'FMaterial',
          FNAME: name,
          FSEX: sex,
          FIDNUM: idNum,
          FCERCAT: infoCardType(userInfo.CARD_TYPE) ,// 证件类型\
          FRegTime: today //就业登记日期
        },
      },
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postData, birthday, formId, name, sex, idNum])
  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        FNAME: idCardHide(name, 1, name.length - 1) || '',
        FSEX: judgeSex(sex),
        FCERCAT: '居民身份证',
        FIDNUM: userInfoHide(userInfo),
        FBIRTH: transformDate(birthday),
        // 显示为当天日期
        FRegTime: today,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthday, sex, name, form, userInfo, idNum]);

  /** 初始化数据 */
  useEffect(() => {
    getAreaObj('', areaContent, setAreaContent)
    getJobWantedObj('', jobWantContent, setJobWantContent)
    const date = dayjs().format('YYYYMMDDHHmmss');
    setFormId(date + guid());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  /**更新提交表单接口参数数据*/
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    // 后端数据为022,为了判断写为！=
    // eslint-disable-next-line eqeqeq
    if (name === 'FWORKTYPE' && value != 22) {
      delete newPostData.FFLEXIBLETYPE
      newPostData[name] = value
      setPostData(newPostData)
    } else {
      newPostData[name] = value
      setPostData(newPostData)
    }
  }

  /**提交表单*/
  async function handleSubmitFormClick(setLoading) {
    if (stepNum < title.length - 1) {
      setStepNum(stepNum + 1)
    }
    if (stepNum === title.length - 1) {
      setLoading(true)
      try {
        const res = await onSubmitForm(postInfo);
        if (res.code === 200) {
          setStepNum(stepNum + 1)
        } else {
          Toast.show({
            icon: 'fail',
            content: '提交失败，请检查内容并重试',
          })
        }
      } catch (error) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false)
      }
    }
  }
  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      form={form}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      getAreaObj={getAreaObj}
      jobWantContent={jobWantContent}
      setJobWantContent={setJobWantContent}
      getJobWantedObj={getJobWantedObj}
      postData={postData}
      postInfo={postData}
      formId={formId}
    />

  return (
    <FromSteps
      stepNum={stepNum} title={title}
      getType={getType} setStepNum={setStepNum}
      form={form} pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}